// Dynatrace global click tracking for links and buttons PoC (DEVWEB-210)
// https://www.dynatrace.com/support/doc/javascriptapi/interfaces/dtrum_types.DtrumApi.html#enterAction

function getTrackingLabel(anchor) {
    if (anchor.hasAttribute('tracking-label')) {
        // Use tracking-label if present
        return anchor.getAttribute('tracking-label');
    }

    if (anchor.hasAttribute('aria-label')) {
        // Use aria-label if present
        return anchor.getAttribute('aria-label');
    }

    // Look for headlines as content
    const headline = anchor.querySelector('h1, h2, h3, h4, h5, h6');
    if (headline) {
        // TODO: also check for aria-label on headline
        return headline.textContent;
    }

    // Fall back to complete textContent of the link
    return anchor.textContent.trimStart().trimEnd().replaceAll('  ', '').replaceAll('\n', ' ');
}

function trackDynatraceAction(actionName, sourceUrl, sourcePathname) {
    if (window.app_config?.dynatraceGlobalClickTrackingLoggingEnabled) {
        console.log(actionName + ' on page ' + sourcePathname);
    }
    if (window.dtrum !== undefined) {
        const actionId = window.dtrum.enterAction?.(actionName, null, null, sourceUrl);
        if (actionId !== undefined) {
            window.dtrum.leaveAction?.(actionId, null, null);
        }
    }
}

function requiresSynchronousTracking(anchor, event) {
    if (event.defaultPrevented) return false;

    if (anchor instanceof HTMLAnchorElement) {
        const target = (anchor.getAttribute('target') || '').toLowerCase();
        const opensNewContext = target !== '' && target !== '_self';
        const usesModifierClick = event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey;

        return !opensNewContext && !usesModifierClick;
    }

    if (anchor instanceof HTMLButtonElement) {
        const type = (anchor.getAttribute('type') || 'submit').toLowerCase();
        return !anchor.disabled && type === 'submit' && anchor.form !== null;
    }

    return false;
}

function handleCustomDynatraceAction(event) {
    const composedPath = event.composedPath?.() || [];
    const anchor = composedPath.find(
        (element) => element instanceof Element && (element.matches('a') || element.matches('button')),
    );

    if (!anchor) return;

    const actionName = 'click ' + getTrackingLabel(anchor);
    const sourceUrl = location.href;
    const sourcePathname = location.pathname;
    const trackAction = () => trackDynatraceAction(actionName, sourceUrl, sourcePathname);

    if (requiresSynchronousTracking(anchor, event)) {
        trackAction();
        return;
    }

    // For non-navigation clicks, defer the Dynatrace API call off the click
    // critical path after capturing immutable click metadata.
    setTimeout(trackAction, 0);
}

let hasAddedEventListener = false;

document.addEventListener('DOMContentLoaded', () => {
    const dynatraceGlobalClickTrackingGroup = window.app_config?.dynatraceGlobalClickTrackingGroup;

    window.addEventListener('OneTrustGroupsUpdated', ({ detail: OptanonActiveGroups }) => {
        if (OptanonActiveGroups.includes(dynatraceGlobalClickTrackingGroup) && !hasAddedEventListener) {
            document.addEventListener('click', handleCustomDynatraceAction);
            hasAddedEventListener = true;
        } else if (!OptanonActiveGroups.includes(dynatraceGlobalClickTrackingGroup) && hasAddedEventListener) {
            document.removeEventListener('click', handleCustomDynatraceAction);
            hasAddedEventListener = false;
        }
    });
});
